// 智慧文书
import ContractTemplate from '../view/Document/ContractTemplate/ContractTemplate'
import NoticeTemplate from '../view/Document/NoticeTemplate/NoticeTemplate'
import HatchTemplate from '../view/Document/HatchTemplate/HatchTemplate'
import DocumentNav from '../view/Document/DocumentNav'
import Log from '../view/log'

export default [
  /* 智慧文书 */
  {
    path: '/contract_template',
    name: 'contract-template',
    components: {
      default: DocumentNav,
      a: ContractTemplate
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/notice_template',
    name: 'notice-template',
    components: {
      default: DocumentNav,
      a: NoticeTemplate
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/hatch_template',
    name: 'hatch-template',
    components: {
      default: DocumentNav,
      a: HatchTemplate
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/document_log',
    name: 'document-log',
    components: {
      default: DocumentNav,
      a: Log
    }
  },
    /* 智慧文书 */
]



// WEBPACK FOOTER //
// ./src/router/Document.js